import React from 'react';
import { collectionsAPI } from '../../api/client';
import { useTranslation } from '../../context/TranslationContext';
import MasterDataManager from '../Common/MasterDataManager';

const Collections = () => {
  const { t } = useTranslation();

  const columns = [
    {
      header: t('collections.code', 'Collection Code'),
      field: 'collection_code',
      className: 'code-column'
    },
    {
      header: t('collections.description', 'Description'),
      field: 'description'
    },
    {
      header: t('created_at', 'Created'),
      field: 'created_at',
      render: (row) => new Date(row.created_at).toLocaleDateString(),
      sortable: false
    }
  ];

  const formFields = [
    {
      name: 'collectionCode',
      label: 'collections.code',
      type: 'text',
      required: true,
      maxLength: 20
    },
    {
      name: 'description',
      label: 'collections.description',
      type: 'text',
      maxLength: 50
    },
    {
      name: 'notes',
      label: 'notes',
      type: 'textarea',
      rows: 3
    }
  ];

  return (
    <MasterDataManager
      title="collections.title"
      subtitle="collections.subtitle"
      createButtonLabel="collections.create"
      api={collectionsAPI}
      columns={columns}
      formFields={formFields}
      idField="collection_id"
      displayField="collection_code"
    />
  );
};

export default Collections;